import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SxProps } from '@mui/material';

import { triggerLogout } from '@atom/actions/userActions';
import { useNavigation } from '@atom/hooks/useNavigation';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import defaultProfileImage from '@atom/images/defaultProfileImage.png';
import { Icon, Popover } from '@atom/mui';
import colors from '@atom/styles/colors';

import classes from './navigation.module.css';

const styles = {
  iconStyle: {
    color: colors.neutral.gray,
    marginRight: '1rem',
  },
};

const sx: SxProps = {
  right: 0,
  width: '168px',
  left: 'auto',
};

const Profile = () => {
  const [, { navigate }] = useNavigation();
  const userProfile = useUserProfile();
  const dispatch = useDispatch();
  const anchor = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState<boolean>(false);

  const handleLogout = () => {
    setOpen(false);
    dispatch(triggerLogout());
  };

  const handleProfileClick = () => {
    setOpen(false);
    navigate(`/team/${userProfile.userId}`);
  };

  return (
    <div className={classes.profileWrapper} ref={anchor}>
      <img
        className={classes.profile}
        onClick={() => setOpen(true)}
        src={userProfile.profileImage}
        onError={(error: any) => {
          error.target.src = defaultProfileImage;
        }}
      />
      <Popover
        open={open}
        anchorEl={anchor.current}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={() => setOpen(false)}
        slotProps={{ paper: { sx } }}
      >
        <div className={classes.menuRow} onClick={handleProfileClick}>
          <Icon style={styles.iconStyle}>account_circle</Icon>
          User Profile
        </div>
        <div className={classes.menuRow} onClick={handleLogout}>
          <Icon style={styles.iconStyle}>exit_to_app</Icon>
          Log Out
        </div>
      </Popover>
    </div>
  );
};

export default Profile;
